import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { CssBaseline, PaletteMode } from '@mui/material'
import { ThemeProvider as MUIThemeProvider, createTheme, StyledEngineProvider } from '@mui/material/styles'
import shadows from './shadows'
import typography from './typography'
import GlobalStyles from './globalStyles'
import customShadows from './customShadows'
import componentsOverride from './overrides'
import { paletteDark, paletteLight } from './palette'

ThemeProvider.propTypes = {
  children: PropTypes.node
}

export default function ThemeProvider ({ children }: any) {
  const mode: PaletteMode = 'dark'
  const palette = (mode.toString() === 'dark') ? paletteDark : paletteLight
  const themeOptions = useMemo(
    () => ({
      palette,
      shape: { borderRadius: 6 },
      typography,
      shadows: shadows(palette),
      customShadows: customShadows(palette)
    }),
    []
  )

  const theme = createTheme(themeOptions)
  theme.components = componentsOverride(theme)
  theme.palette.mode = mode

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles />
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  )
}
